/** 组织/租户展示。登录后由 AuthContext 写入真实租户。 */
export interface Organization {
  id: string;
  name: string;
  shortName: string;
}

/** 未登录或租户信息尚未加载时的占位（营销页等） */
export const DEFAULT_ORG: Organization = {
  id: "udhub",
  name: "UDHUB · 云枢",
  shortName: "云枢",
};

export function orgFromTenant(tenant: {
  id: string;
  name: string;
}): Organization {
  const name = tenant.name.trim() || DEFAULT_ORG.name;
  const short =
    name.length > 12 ? `${name.slice(0, 12)}…` : name;
  return {
    id: tenant.id,
    name,
    shortName: short,
  };
}
